<template>
  <el-dialog
    title="添加"
    :visible.sync="dialogVisible"
    width="40%"
    class="addBusinessUnitDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="addBusinessUnitFrom" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="业务单元名称" prop="unitName">
            <el-input v-model="formData.unitName" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="对应部门" prop="deptCode">
            <el-cascader
              filterable
              ref="deptCascader"
              :props="props"
              v-model="formData.deptCode"
              :show-all-levels="false"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="所属大区">
            <el-input v-model="formData.bigArea" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { businessUnitManagementApi, expensesJurManagementApi } from '@/views/backStageManagement/service';

export default {
  data () {
    return {
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad (node, resolve) {
          const { level } = node;
          let params = '000';
          if (level > 0) {
            params = node.value;
          }
          if (!node.isLeaf) {
            expensesJurManagementApi.getAllDeptList(params).then(res => {
              if (res.status === '200') {
                let nodeList = res.data.map(item => {
                  return {
                    label: item.deptName,
                    value: item.deptCode,
                    leaf: item.type !== '1'
                  };
                });
                resolve(nodeList);
              }
            });
          } else {
            resolve();
          }
        }
      },
      rules: {
        unitName: [
          { required: true, message: '请选择业务单元名称', trigger: 'blur' }
        ],
        deptCode: [
          { required: true, message: '请选择对应部门', trigger: 'change' }
        ]
      },
      formData: {},
      dialogVisible: false,
      deptList: [],
      deptLoading: false
    };
  },
  props: {
    addDialogShow: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    addDialogShow (val) {
      if (val) {
        if (this.rowData.id) {
          this.formData = this.rowData;
        }
        // this.getDeptList('');
      } else {
        this.formData = {};
        this.$nextTick(() => {
          this.$refs.addBusinessUnitFrom.clearValidate();
        });
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    submitHandlen () {
      this.$refs['addBusinessUnitFrom'].validate((valid) => {
        if (valid) {
          let data;
          if (this.formData.id) {
            data = {
              id: this.formData.id,
              unitName: this.formData.unitName,
              deptCode: this.formData.deptCode
            };
            this.$emit('editBusinessUnitHandle', data);
          } else {
            this.formData.deptName = this.$refs['deptCascader'].getCheckedNodes()[0].label;
            data = {
              deptName: this.$refs['deptCascader'].getCheckedNodes()[0].label,
              deptCode: this.formData.deptCode[this.formData.deptCode.length - 1],
              unitName: this.formData.unitName,
              bigArea: this.formData.bigArea ? this.formData.bigArea : ''
            };
            this.$emit('addBusinessUnitHandle', data);
          }
        }
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    getDeptList (val) {
      let params = {
        deptCodeOrName: val
      };
      this.deptLoading = true;
      businessUnitManagementApi.getDeptList(params).then(res => {
        if (res.status === '200') {
          this.deptList = res.data.list;
          this.deptLoading = false;
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
